class IbscentPremiumSlider extends HTMLElement {
  connectedCallback() {
    this.initWhenReady();
    this.setupReveal();
  }

  setupReveal() {
    const section = this.closest('.ibscent-premium');
    if (!section) return;
    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-revealed');
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add('is-revealed');
            observer.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );
    observer.observe(section);
  }

  initWhenReady() {
    if (typeof BlazeSlider === 'function') {
      this.init();
      return;
    }
    const start = Date.now();
    const interval = setInterval(() => {
      if (typeof BlazeSlider === 'function') {
        clearInterval(interval);
        this.init();
      } else if (Date.now() - start > 4000) {
        clearInterval(interval);
      }
    }, 50);
  }

  init() {
    const root = this.querySelector('.blaze-slider');
    if (!root || this.slider) return;
    const slides = root.querySelectorAll('.ibscent-premium__card').length;
    if (slides < 2) return;
    this.slider = new BlazeSlider(root, {
      all: {
        enableAutoplay: true,
        autoplayInterval: 5000,
        stopAutoplayOnInteraction: true,
        slidesToShow: 1,
        slideGap: '0px',
        loop: true,
        draggable: true,
        transitionDuration: 600,
        slidesToScroll: 1,
      },
    });
  }
}

if (!customElements.get('ibscent-premium-slider')) {
  customElements.define('ibscent-premium-slider', IbscentPremiumSlider);
}
